import React from 'react';
import { toast } from 'react-toastify';

interface CopyToClipboardProps {
  textToCopy: string;
  onCopied?: () => void;
  className?: string;
  children: React.ReactNode;
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({ textToCopy, onCopied, className, children }) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      toast.success("Email copiata con successo!");
      if (onCopied) onCopied();
    } catch {
      toast.error("Errore nel copiare l'email");
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={className}
      style={{ display: 'inline-flex', alignItems: 'center', cursor: 'pointer', border: 'none', background: 'none', padding: 0 }}
      aria-label="Copy to clipboard"
    >
      {children}
    </button>
  );
};